/**
 * Report History Configuration
 * Columns and action definitions
 */
import type { TFunction } from 'i18next'
import type {
    DataTableColumn,
    DataTableAction,
} from '@/components/ui/data-table-customized'
import {
    createChipFormatter,
    createDateFormatter,
} from '@/components/ui/data-table-customized'
import { DownloadIcon, EyeIcon } from 'lucide-react'
import type { ReportWAFTask } from '../types/response'

export const getHistoryColumns = (
    t: TFunction
): DataTableColumn<ReportWAFTask>[] => [
    {
        key: 'id',
        title: 'ID',
        width: 70,
        sortable: true,
        render: (value) => `#${value}`,
    },
    {
        key: 'created_at',
        title: t('history.created_at'),
        width: 160,
        sortable: true,
        formatter: createDateFormatter({ format: 'DD/MM/YYYY HH:mm' }),
    },
    {
        key: 'completion_date',
        title: t('history.completion_date'),
        width: 160,
        sortable: true,
        formatter: createDateFormatter({ format: 'DD/MM/YYYY HH:mm' }),
    },
    {
        key: 'report_type',
        title: t('fields.send_frequency'),
        width: 130,
        render: (value) =>
            t(`send_frequency.${value}`, { defaultValue: value as string }),
    },
    {
        key: 'report_name',
        title: t('history.report_name', { defaultValue: 'Report Name' }),
        width: 200,
        render: (value) => (value as string) || '-',
    },
    {
        key: 'send_status',
        title: t('send_status_label'),
        width: 130,
        formatter: createChipFormatter({
            colorMap: {
                pending: { color: 'warning' },
                running: { color: 'info' },
                completed: { color: 'success' },
                failed: { color: 'error' },
            },
        }),
    },
    {
        key: 'file_status',
        title: t('history.file_status'),
        width: 130,
        formatter: createChipFormatter({
            colorMap: {
                ready: { color: 'success' },
                generating: { color: 'warning' },
                error: { color: 'error' },
            },
        }),
    },
]

export const getHistoryActions = (
    t: TFunction,
    handlers: {
        onView: (row: ReportWAFTask) => void
        onDownload: (row: ReportWAFTask) => void
    }
): DataTableAction<ReportWAFTask>[] => [
    {
        key: 'view',
        label: t('history.view_report', { defaultValue: 'View Report' }),
        icon: <EyeIcon className="w-4 h-4" />,
        onClick: handlers.onView,
    },
    {
        key: 'download',
        label: t('history.download_pdf'),
        icon: <DownloadIcon className="w-4 h-4" />,
        onClick: handlers.onDownload,
    },
]
